import {QueryContractInfoResponse} from "@shareledgerjs/types/cosmwasm/wasm/v1/query";

import {BaseClient} from "../../baseclient";
import {WasmQueryExtension} from "../wasm";
import {GetInfoResponse, GetSoulBoundTokenResponse, GetTokenURIResponse, QueryMsg} from "./types/CwSoulbound.types";

export interface SbtQueryExtensionMethods {
  info(contractAddress: string, height?: number): Promise<GetInfoResponse>;
  tokenOf(contractAddress: string, owner: string, height?: number): Promise<string>;
  tokenURI(contractAddress: string, height?: number): Promise<string>;
  metadata(contractAddress: string, height?: number): Promise<QueryContractInfoResponse>;
}

export interface SbtQueryExtension {
  readonly sbt: SbtQueryExtensionMethods;
}

export function SbtQueryExtension<T extends {new (...args: any[]): BaseClient & SbtQueryExtension & WasmQueryExtension}>(
  constructor: T
): T {
  return class extends constructor {
    override get sbt() {
      return {
        ...super["sbt"],
        info: async (contractAddress: string) => {
          const res = await this.wasm.smartContractState<GetInfoResponse, QueryMsg>(contractAddress, {
            get_info: {}
          });
          return res;
        },
        tokenOf: async (contractAddress: string, owner: string) => {
          const res = await this.wasm.smartContractState<GetSoulBoundTokenResponse, QueryMsg>(contractAddress, {
            get_soul_bound_token: {
              soul: owner
            }
          });
          return res.token_id;
        },
        tokenURI: async (contractAddress: string) => {
          const res = await this.wasm.smartContractState<GetTokenURIResponse, QueryMsg>(contractAddress, {
            get_token_uri: {}
          });
          return res.token_uri;
        },
        metadata: async (contractAddress: string) => {
          const res = await this.wasm.contractInfo(contractAddress);
          return res;
        }
      };
    }
  };
}
